import styled from "styled-components";

// Components
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import CommonButton from "../../../../components/common/CommonButton";

// Assets
import WomanThinking from "../../../../assets/media/aden/woman-thinking.png";

const StartSimulatorModal = ({ isOpen, onClose, onStart }) => {
    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContent>
                        <CloseButton onClick={onClose}>x</CloseButton>
                    

                <Content>
                    
                    <ImageSection>
                        <img src={WomanThinking} alt="Persona pensando" width={300} height={300} />
                    </ImageSection>
                    <h1>Iniciar Simulador Sales PRO</h1>
                    <p>Ten en cuenta, que una vez inicies el simulador, <b>no podrás volver atrás.</b></p>
                    <p>¿Deseas avanzar?</p>
                </Content>

                <Footer>
                    <CommonButton
                        label="Volver"
                        variant="outlined"
                        onClick={onClose}
                        icon={<FontAwesomeIcon icon="fa-light fa-arrow-left" size={16} />}
                    />
                    <CommonButton
                        label="Iniciar simulador"
                        variant="filled"
                        onClick={onStart}
                        icon={<FontAwesomeIcon icon="fa-light fa-play" size={16} />}
                    />
                </Footer>
            </ModalContent>
        </ModalOverlay>
    );
};

export default StartSimulatorModal;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease-in-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 1rem;
    position: relative;
    width: 40vw;
    max-height: 90vh;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    overflow: hidden;
    animation: slideIn 0.3s ease-in-out;

    @keyframes slideIn {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const CloseButton = styled.button`
    position: absolute;
    right: 1rem;
    top: 1rem;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    transition: all 0.3s ease-in-out;

    &:hover {
        background-color: #f5f5f5;
        color: #333;
    }
`;

const Content = styled.div`
    padding: 0 2rem;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2rem;

    h1 {
        font-size: 24px;
        color: #b31d15;
    }

    p {
        font-size: 16px;
        color: #222;
    }
`;

const ImageSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 0;

    img {
        max-width: 100%;
        height: auto;
    }
`;

const Footer = styled.div`
    width: calc(100% - 4rem);
    display: flex;
    justify-content: center;
    gap: 2rem;
    padding: 1.5rem 2rem;
    background: white;
`;
